import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui';

export default function styled (Component) {
  return (style, options) => {
    function StyledComponent (props) {
      const { classes, ...other } = props;
      return <Component classes={classes} {...other} />;
    }
    StyledComponent.propTypes = {
      classes: PropTypes.object.isRequired,
      className: PropTypes.string,
    };
    // const styles =
    //   typeof style === 'function' ? theme => ({ root: style(theme) }) : { root: style };
    return withStyles(style, options)(StyledComponent);
  };
}



// WEBPACK FOOTER //
// ./src/components/styling/StyledComponent.js